module.exports = __webpack_public_path__ + "fonts/492e4edf87f8aced3c8d66c4e0055189.svg";